<template>
	<div class="contact-form">
		<h2 class="title title--style5 contact-form__title">
			{{ $t('landing.forms.question.title') }}
		</h2>

		<p class="contact-form__desc">{{ $t('landing.forms.question.desc') }}</p>

		<VForm class="contact-form__form form" ref="form" @submit="onSubmit">
			<div class="form__field">
				<label class="sr-only" :for="`question-${$.uid}-[email]`">
					{{ $t('landing.forms.question.email_placeholder') }}
				</label>

				<VField
					type="email"
					name="email"
					rules="email|required"
					class="text-field text-field--outline"
					:id="`question-${$.uid}-[email]`"
					:placeholder="$t('landing.forms.question.email_placeholder')"
				/>

				<VErrorMessage class="error-message" name="email" as="div" />
			</div>

			<div class="form__field">
				<label class="sr-only" :for="`question-${$.uid}-[question]`">
					{{ $t('landing.forms.question.email_placeholder') }}
				</label>

				<VField
					name="question"
					rules="required"
					as="textarea"
					class="text-area text-area--outline"
					:id="`question-${$.uid}-[question]`"
					:placeholder="$t('landing.forms.question.question_placeholder')"
				/>

				<VErrorMessage class="error-message" name="question" as="div" />
			</div>

			<button class="btn btn--default form__btn" type="submit">
				<span v-if="isLoading" class="btn-preloader"></span>
				{{ $t('landing.forms.question.button_text') }}
			</button>

			<div class="form__field">
				<VField
					v-model="isChecked"
					:class="{ checked: isChecked }"
					:id="`question-${$.uid}-[privacyPolicy]`"
					name="privacyPolicy"
					type="checkbox"
					rules="required"
				/>

				<label
					class="custom-checkbox"
					:for="`question-${$.uid}-[privacyPolicy]`"
					v-html="$t('landing.forms.question.checkbox_text')"
				>
				</label>

				<VErrorMessage class="error-message" name="privacyPolicy" as="div" />
			</div>

			<a href="/privacy-policy" class="contact-form__link link">
				{{ $t('landing.forms.question.link_text') }}
			</a>
		</VForm>
	</div>
</template>

<script>
import { ErrorMessage as VErrorMessage, Field as VField, Form as VForm } from 'vee-validate'
import { sendQuestion } from '@/api/landing/apiQuestion.js'
import { mapActions } from 'pinia'
import { useQuestionsStore } from '@/stores/landing/questions.js'

export default {
	name: 'ContactForm',
	components: { VErrorMessage, VForm, VField },
	data() {
		return {
			isChecked: true,
			isLoading: false
		}
	},
	mounted() {
		if (this.isChecked) {
			// const checkbox = this.$refs.checkbox.$el
			// console.log(checkbox)
			// checkbox.setAttribute('checked', '')
		}
	},
	methods: {
		...mapActions(useQuestionsStore, {
			setModalValues: 'setValues'
		}),
		async onSubmit(values, form) {
			if (this.isLoading) return

			this.isLoading = true

			const response = await sendQuestion(values.email, values.question)

			if (response?.success) {
				this.showModal(
					'landing.modals.question_form.successTitle',
					'landing.modals.question_form.successDesc',
					'landing.modals.question_form.successButtonText'
				)
				form.resetForm()
			} else if (response?.success === false) {
				const messages = Object.entries(response.messages)
				messages.forEach(([field, messages]) => {
					if (messages[this.$i18n.locale]) {
						form.setFieldError(field, messages[this.$i18n.locale])
					}
				})
			} else {
				this.showModal(
					'landing.modals.question_form.errorTitle',
					'landing.modals.question_form.errorDesc',
					'landing.modals.question_form.errorButtonText'
				)
			}

			this.isLoading = false
		},
		showModal(title, desc, buttonText) {
			this.setModalValues(title, desc, buttonText)
			this.$vfm.open('question')
		}
	}
}
</script>
